var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-energy-bg-orange';
                    var viewUrl = 'sprite.svg#view-icon-energy-bg-orange';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 44 62',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };